import React from "react";
import { useDispatch, useSelector } from "react-redux";
import IBAN from "iban";
import axios from "axios";
import texts from "../../texts/texts";
import NumberFormat from "react-number-format";
import useValidateCard from "./hooks/useValidateCard";

export function Unload() {
    const dispatch = useDispatch();
    const card = useSelector((state) => state.card);
    const balance = useSelector((state) => state.balance);
    const pin = useSelector((state) => state.pin);
    const iban = useSelector((state) => state.iban);
    const owner = useSelector((state) => state.owner);
    const errors = useSelector((state) => state.errors);
    const pending = useSelector((state) => state.pending);
    const unloadTimeDiff = useSelector((state) => state.unloadTimeDiff);
    const view = useSelector((state) => state.view);
    const isCardValid = useValidateCard();

    const validateUnload = async () => {
        dispatch({ type: "DELETE_ERROR", error: "unload" });
        dispatch({ type: "DELETE_ERROR", error: "pin" });
        dispatch({ type: "DELETE_ERROR", error: "iban" });
        dispatch({ type: "DELETE_ERROR", error: "owner" });

        if (!isCardValid(card)) {
            return;
        }

        if (pin.length < 4) {
            dispatch({
                type: "ADD_ERROR",
                error: "pin",
            });
            return;
        }

        if (!IBAN.isValid(iban)) {
            dispatch({
                type: "ADD_ERROR",
                error: "iban",
                message: "Bitte prüfen Sie das IBAN Format",
            });
            return;
        }

        if (owner.length < 3) {
            dispatch({
                type: "ADD_ERROR",
                error: "owner",
            });
            return;
        }

        dispatch({
            type: "UPDATE_VIEW",
            view: "unloadConfirm",
        });
    };

    const unload = async () => {
        dispatch({ type: "UPDATE_PENDING", pending: "unload" });
        await axios
            .post(`/api/unload`, {
                card: card,
                pin: pin,
                iban: iban,
                owner: owner,
            })
            .then(function (response) {
                console.log(response);

                dispatch({
                    type: "UPDATE_VIEW",
                    view: "home",
                });

                dispatch({
                    type: "UPDATE_UNLOAD_STATUS",
                    unloadStatus:
                        "Der Restwert Ihrer Karte " +
                        card +
                        " in Höhe von " +
                        parseFloat(response.data.amount).toFixed(2).replace('.', ',') +
                        " € wurde entladen und wird Ihrem Konto " +
                        iban +
                        " in den nächsten drei Werktagen gutgeschrieben. Der aktuelle Kartenwert beträgt 0,00 €.",
                });

                setTimeout(() => {
                    dispatch({
                        type: "UPDATE_UNLOAD_STATUS",
                        unloadStatus: "",
                    });
                }, 30000);

                dispatch({
                    type: "UPDATE_BALANCE",
                    balance: null,
                });

                let d = Date.now();
                localStorage.setItem("unloadTime", d);
                dispatch({ type: "UPDATE_UNLOAD_TIME", unloadTime: d });
            })
            .catch(function (error) {
                console.log(error);
                dispatch({
                    type: "UPDATE_VIEW",
                    view: "unload",
                });

                if (error.response.status == 404) {
                    if (error.response.data.error == "Card not found") {
                        dispatch({
                            type: "ADD_ERROR",
                            error: "card",
                            message: texts.errors.wrongNumber,
                        });
                    } else if (error.response.data.error == "Empty balance") {
                        dispatch({
                            type: "ADD_ERROR",
                            error: "unload",
                            message: texts.errors.emptyBalance,
                        });
                    }
                } else {
                    dispatch({
                        type: "ADD_ERROR",
                        error: "unload",
                        message: texts.errors.unknownError,
                    });

                    let d = Date.now();
                    localStorage.setItem("unloadTime", d);
                    dispatch({ type: "UPDATE_UNLOAD_TIME", unloadTime: d });
                }
            });

        dispatch({ type: "UPDATE_PENDING", pending: "" });
    };

    return (
        <div className="stack stack_large">
            {view == "unload" && (
                <div className="unload stack stack_large">
                    <div className="unload__pin">
                        <label htmlFor="pin">
                            PIN/Autorisierungsschlüssel:
                        </label>
                        <input
                            id="pin"
                            type="text"
                            className={`field ${
                                errors.pin && pin.length < 4
                                    ? "field_error"
                                    : ""
                            }`}
                            value={pin}
                            onChange={(e) =>
                                dispatch({
                                    type: "UPDATE_PIN",
                                    pin: e.target.value,
                                })
                            }
                        ></input>
                    </div>
                    <div className="stack stack_tiny">
                        <label htmlFor="iban">Empfängerkonto (IBAN)</label>
                        <input
                            id="iban"
                            type="text"
                            className={`field ${
                                errors.iban ? "field_error" : ""
                            }`}
                            value={iban}
                            onChange={(e) =>
                                dispatch({
                                    type: "UPDATE_IBAN",
                                    iban: e.target.value,
                                })
                            }
                        ></input>
                        {errors.iban && (
                            <div className="field__error-message small">
                                {errors.iban?.message}
                            </div>
                        )}
                    </div>
                    <div className="stack stack_tiny">
                        <label htmlFor="owner">Kontoinhaber</label>
                        <input
                            id="owner"
                            type="text"
                            className={`field ${
                                errors.owner && owner.length < 3
                                    ? "field_error"
                                    : ""
                            }`}
                            value={owner}
                            placeholder="Vorname Nachname"
                            onChange={(e) =>
                                dispatch({
                                    type: "UPDATE_OWNER",
                                    owner: e.target.value,
                                })
                            }
                        ></input>
                    </div>
                    {errors.unload?.message && (
                        <div className="status status_error">
                            {errors.unload?.message}
                        </div>
                    )}
                    {unloadTimeDiff < 59 && (
                        <div>
                            {Math.round(60 - unloadTimeDiff)} Sekunden warten,
                            um eine weitere Anfrage zu stellen
                        </div>
                    )}
                    <div className="stack stack_small">
                        <button
                            className="button"
                            onClick={() => validateUnload()}
                            disabled={
                                pending == "unload" || unloadTimeDiff < 59
                            }
                        >
                            Weiter
                        </button>
                        <button
                            className="button button_secondary"
                            onClick={() =>
                                dispatch({
                                    type: "UPDATE_VIEW",
                                    view: "home",
                                })
                            }
                        >
                            Zurück zur Übersicht
                        </button>
                    </div>
                </div>
            )}

            {view == "unloadConfirm" && (
                <div className="stack stack_large">
                    <div className="stack stack_big">
                        <p>
                            Bitte überprüfen Sie Ihre Angaben und ändern Sie diese bei
                            Bedarf. Sobald Sie &apos;Bestätigen&apos; wählen,
                            wird die Entladung ausgelöst
                        </p>
                        <div className="stack">
                            <div>
                                <label>Kartennummer</label>
                                <div className="h4">{card}</div>
                            </div>
                            <div>
                                <label>Empfängerkonto (IBAN)</label>
                                <div className="h4">{iban}</div>
                            </div>
                            <div>
                                <label>Kontoinhaber</label>
                                <div className="h4">{owner}</div>
                            </div>
                            {balance && (
                                <div>
                                    <label>Zu entladender Betrag</label>
                                    <div className="h4"><NumberFormat value={parseFloat(balance)} fixedDecimalScale={true} decimalScale={2} decimalSeparator={","} displayType={'text'} suffix={'€'}/></div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="stack stack_small">
                        <button
                            className="button"
                            onClick={() => unload()}
                            disabled={pending == "unload"}
                        >
                            Bestätigen
                        </button>
                        <button
                            className="button button_secondary"
                            onClick={() =>
                                dispatch({
                                    type: "UPDATE_VIEW",
                                    view: "unload",
                                })
                            }
                        >
                            Zurück zur Übersicht
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
